import { injectable } from 'inversify';
import { LoggedInUser } from '../../../state/helperServices/auth/auth.interfaces';
import { AuthService } from '../../../state/helperServices/auth/auth.service';
import { useAppSelector } from '../../../state/hooks';
import {
  ConneqtRepository,
  AccountsRepository,
} from '../../../state/reduxRepositories';
import { Account } from '../../../state/reduxRepositories/accounts/accounts.interfaces';
import {
  ViewConneqtPayload,
  Conneqt,
} from '../../../state/reduxRepositories/conneqt/conneqt.interfaces';
import { createDeepEqualSelector } from '../../../state/selector.helpers';
import { ConneqtPlayerDomain } from '../conneqtPlayer.domain';
import { createConneqtRequestsViewPayload } from '../conneqt.helper';

@injectable()
export class SentConneqtDomain {
  sentConneqts: any;
  conneqts: any;

  constructor(
    private authService: AuthService,
    private conneqtRepository: ConneqtRepository,
    private accountsRepository: AccountsRepository,
    private conneqtPlayerDomain: ConneqtPlayerDomain,
  ) {
    this.createSentConneqtSelector();
  }

  useSentConneqts = (): ViewConneqtPayload[] =>
    useAppSelector(this.sentConneqts);

  dispatchDeleteConneqt = (id: string) => {
    this.conneqtRepository.dispatchDelete(id);
  };

  dispatchInviteSentStatus = (id: string) => {
    this.conneqtPlayerDomain.dispatchInviteSentStatus(id);
  };

  private createSentConneqtSelector = () => {
    this.sentConneqts = createDeepEqualSelector(
      this.conneqtRepository.selectors.resourcesSelector,
      this.authService.loggedInUserSelector,
      this.accountsRepository.selectors.resourcesSelector,
      (
        conneqts: Conneqt[],
        user: LoggedInUser | undefined,
        accounts: Account[],
      ) => {
        if (!user) {
          return [];
        }

        return conneqts
          .filter(
            (conneqt) =>
              conneqt.accountId === user.accountId &&
              !this.conneqtPlayerDomain.hasBeenConneqted(conneqt),
          )
          .map((conneqt) => {
            return createConneqtRequestsViewPayload(conneqt, accounts);
          });
      },
    );
  };
}
